import { errorAlert, successAlert } from "@app/utils/alerts";
import {
  deleteData,
  getData,
  postData,
  putData,
} from "@services/utils/formHelpers";
import { create } from "zustand";

type useMasterTablesType = {
  loading: boolean;
  loadingSpecificTable: boolean;
  loadingSave: boolean;
  loadingDelete: boolean;
  currentTableDataList: any[];
  genericTablesList: string[];
  atributtes: string[];
  fetchGenericTables: () => Promise<void>;
  fetchSpecificTable: (table: string) => Promise<
    | {
        dataList: [key: string, value: string][];
        atributes: string[];
      }
    | undefined
  >;
  fetchEquipoMide: () => Promise<
    | {
        dataList: [key: string, value: string][];
        atributes: string[];
      }
    | undefined
  >;
  get: (id: number) => [key: string, value: string] | undefined;
  resetData: () => void;
  deleteData: (id: string, table: string) => Promise<void>;
  save: (
    data: [key: string, value: string],
    tableName: string
  ) => Promise<boolean>;
  currentDataName: string;
  setCurrentDataName: (name: string) => void;
};

export const useMasterTables = create<useMasterTablesType>((set, get) => ({
  loading: false,
  loadingSave: false,
  loadingSpecificTable: false,
  loadingDelete: false,
  genericTablesList: [],
  currentTableDataList: [],
  atributtes: [],
  currentDataName: "",
  setCurrentDataName: (name) => set({ currentDataName: name }),
  get: (id) =>
    get().currentTableDataList.find((tableRegister) => tableRegister.id === id),
  resetData: () => {
    set(() => ({
      loading: false,
      loadingSpecificTable: false,
      currentTableDataList: [],
      atributtes: [],
    }));
  },
  fetchGenericTables: async () => {
    set({ loading: true });
    try {
      const endpoint = `/generic/all-entities`;
      const { data: response } = await getData(endpoint);
      const daleteElements = [
        "CalibrationTritium",
        "ReporteTiposAnalisis",
        "IsotopeResultCalculation",
        "ProcessingCategory",
        "CalibrationUncertainty",
        "Efficiencies",
        "TiposCantidades",
        "UncertaintiesAaFeNi",
        "EfficienciesIsotopes",
        "AdjustmentCurve",
      ];

      set(() => ({
        genericTablesList: response
          .filter((table) => !daleteElements.includes(table))
          .sort(
            (a, b) =>
              a.localeCompare(b, undefined, { sensitivity: "base" }) ||
              a.localeCompare(b, undefined, { sensitivity: "base" })
          ),
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useBackground:", error);
      set({ loading: false });
    }
  },
  fetchSpecificTable: async (table: string) => {
    set({ loadingSpecificTable: true });
    try {
      const endpoint = `/generic/${table}`;
      const endpointAtributes = `/generic/${table}/attributes`;
      const { data: responseDataList } = await getData(endpoint);
      const { data: responseAtributes } = await getData(endpointAtributes);

      set(() => ({
        currentTableDataList: responseDataList as [
          key: string,
          value: string
        ][],
        atributtes: responseAtributes,
        loadingSpecificTable: false,
      }));
      return { dataList: responseDataList, atributes: responseAtributes };
    } catch (error) {
      console.error("Error fetching useBackground:", error);
      set({ loadingSpecificTable: false });
    }
  },
  deleteData: async (id: string, table: string) => {
    set({ loadingDelete: true });
    try {
      const endpoint = `/generic/${table}/${id}`;
      await deleteData(endpoint);
      successAlert("Registro eliminado correctamente");
      await get().fetchSpecificTable(table);
      set({ loadingDelete: false });
    } catch (error) {
      errorAlert("Error al eliminar el registro");
      console.error("Error fetching useBackground:", error);
      set({ loadingDelete: false });
    }
  },
  save: async (data, tableName) => {
    set({ loadingSave: true });
    let hasErrors = false;

    try {
      const id = data["id"];
      const restData = Object.fromEntries(
        Object.entries(data).filter(([key]) => key !== "id")
      );
      const isNew = !data["id"];
      const endpoint = `/generic/${tableName}${isNew ? "" : "/" + id}`;

      const response = isNew
        ? await postData(endpoint, data)
        : await putData(endpoint, restData);

      hasErrors = !response.success;
      if (hasErrors) {
        errorAlert("Error al guardar el registro");
      } else successAlert("Registro guardado correctamente");

      return hasErrors;
    } catch (error) {
      errorAlert("Error al guardar el registro");
      hasErrors = true;
      return hasErrors;
    } finally {
      set({ loadingSave: false });
    }
  },
  fetchEquipoMide: async () => {
    set({ loadingSpecificTable: true });
    try {
      const endpoint = `/generic/EquipoMide`;
      const { data: responseDataList } = await getData(endpoint);

      set(() => ({
        currentTableDataList: responseDataList as [
          key: string,
          value: string
        ][],
        atributtes: [],
        loadingSpecificTable: false,
      }));
      return { dataList: responseDataList, atributes: [] };
    } catch (error) {
      console.error("Error fetching fetchEquipoMide:", error);
      set({ loadingSpecificTable: false });
    }
  },
}));
